import React from 'react';

import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons';

import { Alert } from 'components/ui/alert';
import { Button } from 'components/ui/button';

export default function BillingAccountDetail() {
  return (
    <div className="d-flex flex-column align-items-center">
      <Alert className="mb-4" icon={faInfoCircle} severity="info">
        Please note if you are new to Buildout, your account will be available in Stripe within 5-7 business days.
      </Alert>

      <Button
        href="https://billing.stripe.com/p/login/3cI9AUaIH4gl2SNfFG5AQ00"
        label="Payment Portal"
        rel="noreferrer"
        target="_blank"
      />

      <p className="mt-4">
        <a
          href="https://help.buildout.com/en/articles/8709404-managing-billing-for-your-brokerage-in-buildout"
          rel="noreferrer"
          target="_blank"
        >
          Learn more about the billing updates
        </a>
      </p>
    </div>
  );
}
